import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import ActivityModal from '@/components/ActivityModal';

export default function ActivityPage() {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!workspaceId) navigate('/dashboard');
  }, [workspaceId, navigate]);

  if (!workspaceId) return null;

  return (
    <ActivityModal
      open={true}
      onClose={() => navigate(`/roadmap/${workspaceId}`)}
      workspaceId={workspaceId}
    />
  );
}
